import { Box, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { vascularAPBI, vascularDoppler, vascularLeftOptions, vascularRightOptions, vasularPulsesOption } from './formFootOptions';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm';

const PresentingComplaintOptionsContainer = (props)=>{
    const {heading, children } = props;
    return (
      <>
        <InputContainer>
          <CustomInputLable>{heading}</CustomInputLable>
          <Box sx={{ display: "flex", flexDirection: "column", gap:"0.5rem", maxHeight: "80px", justifyContent: "space-evenly" }}>
            <CustomInputLable>L</CustomInputLable>
            <CustomInputLable>R</CustomInputLable>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap:"0.5rem", width: "100%" }}>
            {children}
          </Box>
        </InputContainer>
      </>
    );
  };

const VascularSupply = (props) => {
    const {control, errors, getValues} = props

    const vasular_pulses = [
        {labelName:"Pulses Left Leg",field_names: [
           {form_field_name:"vascular_supply.vPlulses_left_leg.dorsalis_pedis",  label: "Dorsalis Pedis Pulse",},
            {form_field_name:"vascular_supply.vPlulses_left_leg.anterior_tibial",  label:"Anterior Tibial "},
            {form_field_name:"vascular_supply.vPlulses_left_leg.posterior_tibial",  label:"Posterior Tibial"},
            {form_field_name:"vascular_supply.vPlulses_left_leg.popliteal",  label:"Popliteal"}
        ],
        option:vasularPulsesOption },

        {labelName:"Pulses Right Leg",field_names: [
            {form_field_name:"vascular_supply.vPulses_right_leg.dorsalis_pedis",  label:"Dorsalis Pedis Pulse"},
            {form_field_name:"vascular_supply.vPulses_right_leg.anterior_tibial",  label:"Anterior Tibial "},
            {form_field_name:"vascular_supply.vPulses_right_leg.posterior_tibial",  label:"Posterior Tibial"},
            {form_field_name:"vascular_supply.vPulses_right_leg.popliteal",  label:"Popliteal"},
        ], option:vasularPulsesOption },
    ]


    const vascularLegsLeft = [
        {labelName:"Left Leg", subLabel: "Dorsalis Pedis Pulse", field_names: [
            {form_field_name:"vascular_supply.left_leg.dorsalis_pedis",  label:"Mono Phasic "},
            {form_field_name:"vascular_supply.left_leg.dorsalis_pedis",  label:"Bi Phasic "},
            {form_field_name:"vascular_supply.left_leg.dorsalis_pedis",  label:"Tri Phasic"},
            {form_field_name:"vascular_supply.left_leg.dorsalis_pedis",  label:"Inaudible Posterior Tibial"}],
             option:vascularLeftOptions },
             
             {labelName:"Right Leg", subLabel: "Dorsalis Pedis Pulse", field_names: [
              {form_field_name:"vascular_supply.right_leg.dorsalis_pedis",  label:"Mono Phasic "},
              {form_field_name:"vascular_supply.right_leg.dorsalis_pedis",  label:"Bi Phasic "},
              {form_field_name:"vascular_supply.right_leg.dorsalis_pedis",  label:"Tri Phasic"},
             {form_field_name:"vascular_supply.right_leg.dorsalis_pedis",  label: "Inaudible Posterior Tibial"}], option:vascularRightOptions },
      
    ]

    const vascularLegRight = [
      {labelName:"Left Leg", subLabel: "Posterior Tibial", field_names: [
        {form_field_name:"vascular_supply.left_leg.posterior_tibial",  label:"Mono Phasic "},
        {form_field_name:"vascular_supply.left_leg.posterior_tibial",  label:"Bi Phasic "},
        {form_field_name:"vascular_supply.left_leg.posterior_tibial",  label:"Tri Phasic"},
        {form_field_name:"vascular_supply.left_leg.posterior_tibial",  label:"Inaudible Posterior Tibial"}],
         option:vascularLeftOptions },
    
        
           {labelName:"Right Leg", subLabel: "Posterior Tibial" , field_names: [
            {form_field_name:"vascular_supply.right_leg.posterior_tibial",  label:"Mono Phasic "},
            {form_field_name:"vascular_supply.right_leg.posterior_tibial",  label:"Bi Phasic "},
            {form_field_name:"vascular_supply.right_leg.posterior_tibial",  label:"Tri Phasic"},
           {form_field_name:"vascular_supply.right_leg.posterior_tibial",  label: "Inaudible Posterior Tibial"}], option:vascularRightOptions },
    ]



  return (
    <ParentContainerSection heading="Section G – Assessment of Vascular Supply">
           {vasular_pulses.length && vasular_pulses.map((item,index)=>(
            <InputContainer key={index} sx={{ border:"1px solid", borderRadius:"12px"}}>
          <CustomInputLable required>{item.labelName}</CustomInputLable>
                <Box sx={{ display:"flex", flexDirection: "column", alignItems: "center", gap:"1rem", width:"100%",  }}>
                {item.field_names.map((fieldName, fieldIndex)=>(
                    <Box sx={{ display:"flex", alignItems: "center", gap:"1rem", width:"100%"}} key={fieldIndex}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", minWidth:"fit-content"}}>{fieldName.label}</InputLabelStyled>
                    <RadioButtonController
                                name={fieldName.form_field_name}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={item.option}
                                isHorizantalPadding={true}
                                isDisabled
                            />
                    </Box>
                ))}
                </Box>
               
                </InputContainer>
        ))}

        <InputContainer >
          <CustomInputLable required>Doppler</CustomInputLable>
                <RadioButtonController
                                name="vascular_supply.vDoppler"
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={vascularDoppler}
                                isDisabled
                            />
                </InputContainer>

                
                <InputContainer  >
                <CustomInputLable >APBI</CustomInputLable>
                <CheckboxController
                                name="vascular_supply.vABPI"
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                options={vascularAPBI}
                                isCustomPadding
                                isDisabled
                            />
                </InputContainer>

        <PresentingComplaintOptionsContainer heading="Dorsalis Pedis Pulse">
          {vascularLegsLeft.length && vascularLegsLeft.map((vascuLegs,index)=>(

            <RadioButtonController key={vascuLegs.field_names[index].form_field_name}
              name={vascuLegs.field_names[index].form_field_name}
              isRow={true}
              control={control}
              errors={errors}
              isDisabled
              options={vascuLegs.option}
            />
          ))}
        </PresentingComplaintOptionsContainer>

        <PresentingComplaintOptionsContainer heading="Posterior Tibial" >
          {vascularLegRight.length && vascularLegRight.map((vascuLegs,index)=>(
            <RadioButtonController key={vascuLegs.field_names[index].form_field_name}
              name={vascuLegs.field_names[index].form_field_name}
              isRow={true}
              control={control}
              errors={errors}
              isDisabled
              options={vascuLegs.option}
            />
          ))}
        </PresentingComplaintOptionsContainer>
                    
                </ParentContainerSection>
  )
}

export default VascularSupply